import {Breadcrumbs} from '@management-ui/core';
import {Paper} from '@mui/material';
import * as React from 'react';
import Table from './Table';

const Administrators = () => {
  return (
    <div>
      <Breadcrumbs crumbs={[{title: 'Administrators'}]}/>
      <Paper>
        <Table/>
      </Paper>
    </div>
  );
};

export default Administrators;
